 
import React from 'react';
// import UsaIcon from '../../usa/components/UsaIcon';
// import C18Button00 from '../../usa/components/C18Button00';
// import C18Input00 from '../../usa/components/C18Input00';
// import {acctFeature} from '../../usa/components/C18utils'
import {wsTrans,doGetPostBasic} from '../../usa/utils/utils';
import {cl, getTime,constant,globs,getRandomString} from '../../components/utils/utils';
// import C18Confirm00 from '../../usa/components/C18Confirm00'


class ShowRecipe extends React.Component{
  constructor(props) {
    super(props);
    cl(props)
//     cl(globs)
    this.state={
      loaded:true
    }
    this.props.getValue(props.ind, {type: "scalar"})
//     cl(props)
//     this.state={
//       showBrowse:false,
//       screenWidth: window.innerWidth,
//       images:[],
//       popup:{
//         opacity:0,
//         text:"Are you sure?",
//         buttons:["Close"],
//         resolve:null,
//       },
//     }
//     this.subscribe_fuiImage=globs.events.subscribe("fuiImage",this.fuiImage)
//     this.subscribe_channelTypeChanged=globs.events.subscribe("channelTypeChanged",this.loadInfo)
//     this.props.getValue(props.ind, {type: "local"})
//     this.loadInfo()
//       <div dangerouslySetInnerHTML={{__html: this.props.custom.text}}></div>
  }

  componentDidMount() {
    this.loadInfo()
  }

  loadInfo=async()=>{
    let {zoneInfo,zuci}=this.props
// get all dosers on site. find the one that has this valve:
    let siteId=globs.userData.session.siteId
    let zoneIds=globs.zonesInfo.info.filter(z=>z.siteId==siteId).map(z=>z.zoneId)
    let body={
      zoneId:{$in:zoneIds},
      type:{$in:["valves","recipes","recipeSegments"]}
    }
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlDoser",
      method: "retrieve",
      sessionId: globs.userData.session.sessionId, body: body})
    let doserInfo=res.data
    let [z,u,c,i]=zuci.split("-")
    let valveKey=[z,c].join("-")
    let doserEnt=doserInfo.filter(r=>r.type=="valves").find(r=>{
      return r.value.find(v=>v==valveKey)
    })
    if(doserEnt){
      let doser={}
      doserInfo
        .filter(d=>d.zoneId==doserEnt.zoneId)
        .forEach(d=>doser[d.type]=d)
      this.setState({doser})
    }
  }

  findRecipe=(doser)=>{
    let {value}=this.props// dayMins of startTime
//     cl(value)
    let {recipeId}=doser.recipeSegments.value.find(v=>v.end>value)||{}
    return doser.recipes.value.find(r=>r.recipeId==recipeId)
  }

  render(){
    let {doser}=this.state
    if(!doser){return null}
    let recipe=this.findRecipe(doser)
      return(
        <div style={{display:"inline-block"}}>
          Recipe: {(recipe)?recipe.name:"Water"}
        </div>
      );
  }
}

  export default ShowRecipe ;
